import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,AlertController, DateTime, Platform, ModalController} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,NUBE_AWS,URL_SERVICIOS_LOCALESFRONT } from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { InformesProvider } from '../../providers/informes/informes'
import * as papa from 'papaparse'
import { Observable } from 'rxjs/Observable';
import { ProveedoresCargarStockProvider } from '../../providers/proveedores-cargar-stock/proveedores-cargar-stock'
import { CajaProvider } from '../../providers/caja/caja'
import { UtilsProvider } from '../../providers/utils/utils'
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { Base64 } from 'js-base64';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { SocialSharing } from '@ionic-native/social-sharing';
import { WhatsappPage } from '../whatsapp/whatsapp';
import { ClienteSelectPage } from '../cliente-select/cliente-select';
import { DianProvider } from '../../providers/dian/dian';
import { valueDisplay } from '../../models/valueDisplay.model';
import * as fromClienteSelect from '../cliente-select/state/cliente-select/cliente-select-accions'
import { State } from '../../store/app.reducer'
import { Store } from '@ngrx/store';
import { EntidadesProvider } from '../../providers/entidades/entidades';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-cuentas-por-cobrar',
  templateUrl: 'informe-cuentas-por-cobrar.html',
  providers: [ AuthService ,InAppBrowser,ParametrosGeneralesRedux, DianProvider,
    EntidadesProvider]
})
export class InformeCuentasPorCobrarPage {
  datosPagina:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  fechaDesde:Date
  fechaHasta:Date
  imprimirNombreInforme:string=''
  TodasConSaldo: TodasConSaldo[] = []
  clienteId = []
  TodasConSaldoSelect: string = "T"

  parsedData:any
  parsedDataReal:any
  parseDataHeader:any
  companiasId;
  bluetooth
  resumenCuentasPorCobrarConEstado = []
  resumenCuentasPorCobrarConEstadoPorEntidad = []
  resumenSeguimientosCuentasPorCobrar = []
  resumenSeguimientosCuentasPorCobrarTotales = []
  resumenCuentasPorCobrarPlanDePago = []
  listaClientes = [];
  valoresCliente: string = 'Buscar Cliente';
  isLoading: boolean = false;
  descripcionFactura: string = '';
  entidadesId:any
  fechaInformeSeguimientosPorEntidadAgrupado:any;
  public cancelar$ = new Subject();
  cargando: boolean = false;
  progreso: number = 0;
  paginaActual: number = 1;
  cantidadDeRegistros: number = 50; // Cambia según la cantidad de registros por página
  totalRegistros: number = 0;
  registrosProcesados:number = 0
  constructor(public navCtrl: NavController, public navParams: NavParams,
      public alertControllers:AlertController,
      public storages:Storage,
      public auth: AuthService,
      public servicioCompania:CompaniasProvider,private iab: InAppBrowser,
      public servicio:InformesProvider,
      public servicioClientes:CajaProvider,
      public mensajeria:UtilsProvider,
      public servicioStock:ProveedoresCargarStockProvider,
      public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
      private socialSharing: SocialSharing,
      public platforms: Platform,
      public modalControllers: ModalController,
      public dian: DianProvider,
      private store:Store<State>,
      public servicioEntidades: EntidadesProvider,) {


    this.TodasConSaldo.push({nombre:"Todas",valor:"T"},{nombre:"Solo con Saldo", valor:"S"})

    if(!MODO_DESCONECTADO){
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
        }
      })
      this.storages.set('informeIngresoMercanciaPorDia','')
      }else{
        this.navCtrl.setRoot('PrincipalPage');
      }
      this.buscarDatosIniciales()
  }

  async buscarDatosIniciales() {
    let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
    if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
      this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
      this.bluetooth = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth
    } else {
      this.storages.get('companiasId').then((val) => {
        this.companiasId = val
      })
    }
  }

  generarPlanDePago(numerFactura:string) {
    this.storages.get('companiasId').then((val) => {
    this.servicio.informeResumenCuentasPorCobrarPlanDePago(numerFactura,val).subscribe
    ((datos)=>{
      let res = JSON.parse(datos['_body']).data[0]
      this.resumenCuentasPorCobrarPlanDePago = res
    })
  })
}

seguimientosPorEntidad(entidad: any) {
  this.storages.get('companiasId').then(async (val) => {
    let entidad = 0
    if(this.entidadesId != undefined) {
      entidad = this.entidadesId.length > 0 ? this.entidadesId[0].value : 0
    }
    this.isLoading = true;
    let response: any = await this.servicio.buscarSeguimientosDetalladosCuentasPorCobrarPorEntidad(val, entidad )
    this.resumenCuentasPorCobrarConEstadoPorEntidad = response
    if(this.resumenCuentasPorCobrarConEstadoPorEntidad.length==0) {
        this.isLoading = false;
        this.mensajeria.mensajeMuestro('La entidad seleccionado no tiene cuentas por pagar','Advertencia!','Advertencia')
        return
      } else {
        let data = this.resumenCuentasPorCobrarConEstadoPorEntidad
        const combinedData = ([] as any[]).concat(...data);
        this.servicio.exportToExcel(combinedData, 'seguimientos-por-entidad')
        .then((result: any) => {
            this.isLoading = false;
            console.log('result', result)
          }).catch((error)=> {
            this.isLoading = false;
            console.log('error', error)
          })
      }
  })
}



seguimientosPorEntidadAgrupado(entidad: any) {
  this.storages.get('companiasId').then(async (val) => {
    let entidadId = 0;
    if (this.entidadesId != undefined) {
      entidadId = this.entidadesId.length > 0 ? this.entidadesId[0].value : 0;
    }

    let fechas = this.fechaInformeSeguimientosPorEntidadAgrupado;
    this.isLoading = true;
    this.cargando = true;
    this.progreso = 0;
    this.paginaActual = 1;
    this.cantidadDeRegistros = 300;
    this.registrosProcesados = 0;
    // 🔹 Obtener el número total de registros y páginas
    let primeraConsulta = await this.servicio.buscarSeguimientosDetalladosCuentasPorCobrarPorEntidadAgrupado(val, entidadId, fechas[0], 0, this.cantidadDeRegistros);
    let respuesta = JSON.parse(primeraConsulta['_body']).data[0][0];
    this.totalRegistros = respuesta.totalRegistros; // Se debe obtener del backend
    let totalPaginas = respuesta.totalPaginas;

    // 🔹 Si no hay datos, mostrar mensaje y salir
    if (totalPaginas === 0) {
      this.isLoading = false;
      this.cargando = false;
      this.mensajeria.mensajeMuestro('No hay cuentas por cobrar', 'Advertencia!', 'Advertencia');
      return;
    }

    let todasLasPaginas = [];

    // 🔹 Obtener registros de todas las páginas de forma secuencial
    for (this.paginaActual = 1; this.paginaActual <= totalPaginas; this.paginaActual++) {
      let datos = await this.servicio.buscarSeguimientosDetalladosCuentasPorCobrarPorEntidadAgrupado(val, entidadId, fechas[0], this.paginaActual, this.cantidadDeRegistros);
      let res = JSON.parse(datos['_body']).data[0];

      if (res.length > 0) {
        todasLasPaginas = todasLasPaginas.concat(res);
        this.registrosProcesados += res.length;
      }

      // 🔹 Actualizar progreso
      this.progreso = Math.min(100, Math.round((this.paginaActual * this.cantidadDeRegistros / this.totalRegistros) * 100));

      await this.delay(500);
    }

    // 🔹 Exportar a Excel si hay datos
    if (todasLasPaginas.length > 0) {
      this.servicio.exportToExcel(todasLasPaginas, 'seguimientos-por-entidad')
        .then(result => {
          this.isLoading = false;
          this.cargando = false;
          console.log('result', result);
        }).catch(error => {
          this.isLoading = false;
          this.cargando = false;
          console.log('error', error);
        });
    } else {
      this.isLoading = false;
      this.cargando = false;
    }

  }).catch(error => {
    this.isLoading = false;
    this.cargando = false;
    console.error('Error al obtener datos:', error);
  });
}

async delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

  buscarPlanDePagos() {
    let fechaDesde = this.fechaDesde
    let fechaHasta = this.fechaHasta

  this.storages.get('companiasId').then((val) => {
      let clienteId = 0
      if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
        clienteId = this.clienteId[0]['value']
      }
      let fechadesde = fechaDesde
      let fechahasta = fechaHasta
      if(clienteId == 0) {
        this.mensajeria.mensajeMuestro('Debe seleccionar un cliente','Advertencia!','Advertencia')
        return
      }
      this.servicio.buscarResumenCuentasPorCobrarConEstado(0,clienteId,fechadesde,fechahasta,'T', val).subscribe
      ((datos)=>{
        let res = JSON.parse(datos['_body']).data[0]
        this.resumenCuentasPorCobrarConEstado = res
        if(this.resumenCuentasPorCobrarConEstado.length==0) {
          this.mensajeria.mensajeMuestro('El cliente seleccionado no tiene cuentas por pagar','Advertencia!','Advertencia')
          return
        }
    })
    })
  }

  buscarSeguimientoCuentasPorCobrar(item:any) {
    let fechaDesde = this.fechaDesde
    let fechaHasta = this.fechaHasta

  this.storages.get('companiasId').then((val) => {
      let clienteId = 0
      if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
        clienteId = this.clienteId[0]['value']
      }
      let fechadesde = fechaDesde
      let fechahasta = fechaHasta
      if(clienteId == 0) {
        this.mensajeria.mensajeMuestro('Debe seleccionar un cliente','Advertencia!','Advertencia')
        return
      }

      this.servicio.buscarSeguimientosDetalladosCuentasPorCobrar(val,clienteId,item.id).subscribe
      ((datos)=>{
        let res = JSON.parse(datos['_body']).data
        this.resumenSeguimientosCuentasPorCobrar = res[0]
        this.resumenSeguimientosCuentasPorCobrarTotales = res[1]

        if(this.resumenSeguimientosCuentasPorCobrar.length==0 && this.resumenSeguimientosCuentasPorCobrarTotales.length == 0) {
          this.mensajeria.mensajeMuestro('El cliente seleccionado no tiene seguimientos para esta cuenta por cobrar','Advertencia!','Advertencia')
          return
        }
    })
    })
  }

  printD() {
    this.storages.get(this.imprimirNombreInforme).then((val) => {
      if(val){
        let data = JSON.parse(val)
        let Obj = this.armarImpresion(data)
        this.imprimirArchivoBlue(Obj)
      }else{
        this.mensajeria.mensajeMuestro('Debe buscar Información antes de poder imprimirla','Advertencia!','Advertencia')
      }
    })

  }

  imprimirArchivoBlue(datos) {
    let datanew = datos
    let recibo = ''

    for (let index:any = 0; index < datanew.length; index++) {
      recibo +=  '   ' + datanew[index]['reciboCaja'] + '\n'
    }

    let encodedString = Base64.encode(recibo);
    window.open(`sartprintbluetooth://print/${encodedString}`, '_self');

  }

  abrirWhatsAppResumen() {
      if(this.resumenCuentasPorCobrarConEstado.length> 0){
        // Usamos map para devolver solo los campos que nos interesan
        const filteredData = this.resumenCuentasPorCobrarConEstado.map(item => ({
          "Entidad": item.nombreEntidad,
          "Identificacion": item.identificacion,
          "Nombre": item.nombreCompleto,
          "Valor factura": item.valorFactura.toLocaleString('es-CO'),  // Formateo de valorFactura con separador de miles
          "Valor pagado": item.valorPagado.toLocaleString('es-CO')
        }));

        let data = JSON.stringify(filteredData)
        let numeroTelefono = this.resumenCuentasPorCobrarConEstado[0].numeroTelefono
      let modal = this.modalControllers.create(WhatsappPage, { dataImprimir: data, numeroTelefono: numeroTelefono, descripcionFactura: this.descripcionFactura, espacios: true }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
        }
      })
    }
  }

  abrirWhatsApp() {
    this.storages.get(this.imprimirNombreInforme).then((val) => {
      if(val){
      let modal = this.modalControllers.create(WhatsappPage, { dataImprimir: val, numeroTelefono: '', espacios: true }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
        }
      })
    }
    })
  }

  enviarWhatsApp() {

    this.storages.get(this.imprimirNombreInforme).then((val) => {
      if(val){
        let datanew = JSON.parse(val)
        let recibo = ''
        recibo +=  '   Asi vamos...: ' + '\n'
        let data = []
        let numero = datanew.length > 0 ? datanew[0].numeroTelefono : '0000000000'
        for (let index:any = 0; index < datanew.length; index++) {
          let numerosaldo = datanew[index].saldo.toLocaleString('en');
          let numerovalorFactura = datanew[index].valorFactura.toLocaleString('en');
          let numerovalorPagado = datanew[index].valorPagado.toLocaleString('en');
          recibo +=  '   Fecha: ' + datanew[index].fechaFactura + '\n'
          recibo +=  '   Identificacion: ' + datanew[index].identificacion + '\n'
          recibo +=  '   Nombre completo: ' + datanew[index].nombreCompleto + '\n'
          recibo +=  '   Número factura: ' + datanew[index].numeroFactura + '\n'
          recibo +=  '   Saldo: ' + numerosaldo + '\n'
          recibo +=  '   Factura: ' + numerovalorFactura + '\n'
          recibo +=  '   Pagado: ' + numerovalorPagado + '\n'
          recibo +=  '  ------------------------------------------------ ' + '\n'
          data.push(recibo)
        }

          const url = `https://api.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(
                    recibo
          )}`;
         window.open(url, '_system');

      }else{
        this.mensajeria.mensajeMuestro('Debe buscar Información antes de poder generar el pdf','Advertencia!','Advertencia')
      }
    })




  }
  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  async generarPDF(data: any) {
    this.isLoading = true;
    let responseCompania = await this.dian.devolverCompania()
    this.companiasId = this.companiasId == undefined ? responseCompania : this.companiasId

    if(this.companiasId == undefined) {
      this.companiasId = 2
    }
    this.storages.get(this.imprimirNombreInforme).then(async (val) => {
      if(val){
        let datanew = JSON.parse(val)
        let recibo = ''
        let data = []

        for (let index:any = 0; index < datanew.length; index++) {
          let numerosaldo = datanew[index].saldo.toLocaleString('en');
          let numerovalorFactura = datanew[index].valorFactura.toLocaleString('en');
          let numerovalorPagado = datanew[index].valorPagado.toLocaleString('en');
          recibo +=  '   Fecha: ' + datanew[index].fechaFactura + '\n'
          recibo +=  '   Identificacion: ' + datanew[index].identificacion + '\n'
          recibo +=  '   Nombre completo: ' + datanew[index].nombreCompleto + '\n'
          recibo +=  '   Número Factura: ' + datanew[index].numeroFactura + '\n'
          recibo +=  '   Saldo: ' + numerosaldo + '\n'
          recibo +=  '   Factura: ' + numerovalorFactura + '\n'
          recibo +=  '   Pagado: ' + numerovalorPagado + '\n'
          recibo +=  '  ------------------------------------------------ ' + '\n'
          data.push(recibo)
        }


        const estilo = {
          encabezado: {
            fontSize: 22,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 10], // Margen inferior de 10 unidades
          },
          parrafo: {
            fontSize: 12,
            alignment: 'center',
            margin: [0, 0, 0, 5], // Margen inferior de 5 unidades
          },
          cita: {
            italics: true,
            alignment: 'center',
            margin: [0, 0, 0, 10], // Margen inferior de 10 unidades
          },
          lista: {
            fontSize: 20,
            bold: true,
            margin: [0, 0, 0, 5], // Margen inferior de 5 unidades
          },
        };

    const docDefinition = {
      content: [
        {
          image: await this.getBase64ImageFromURL(`assets/imgs/${this.companiasId}.jpeg`),
          width: 200, // Ancho de la imagen en unidades
          alignment: 'center',
        },
    { text: 'Este es tu resumen', style: 'encabezado' },
     { text: '\n' },
        {
          ul: data.map((dato) => {
            return dato.toString();
          }),
          style: 'lista',
        },
      ],
      styles: estilo
    };



    pdfMake.createPdf(docDefinition).download(`${this.imprimirNombreInforme}.pdf`);
    this.isLoading = false;
      }else{
        this.mensajeria.mensajeMuestro('Debe buscar Información antes de poder generar el pdf','Advertencia!','Advertencia')
        this.isLoading = false;
      }
      this.isLoading = false;
    })







  }


  ionViewDidLoad() {
  }
  public event = {
    default: "ddd MMM DD YYYY HH:mm:ss"
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  valoresTodasConSaldo(data: string){
    this.TodasConSaldoSelect = data
  }

  buscarInformacion(){
    let fechaDesde = this.fechaDesde
    let fechaHasta = this.fechaHasta
  this.storages.get('companiasId').then((val) => {
      let clienteId = 0

      if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
        clienteId = this.clienteId[0]['value']
      }

      if(fechaDesde!==undefined && fechaHasta!==undefined){
        let nombreInforme ='informeCuentasPorCobrar'
        let valoresInformes = `&companiasId=${val}&clientesId=${clienteId}&TodasConSaldo=${this.TodasConSaldoSelect}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
        this.imprimirNombreInforme =`${nombreInforme}-${val}`
        if( NUBE_AWS) {
          let companiaId = val
          let fechadesde = fechaDesde
          let fechahasta = fechaHasta
          let nombre = nombreInforme
          this.servicio.buscarinformeCuentasPorCobrarAWS(nombre,companiaId,clienteId,this.TodasConSaldoSelect,fechadesde,fechahasta)
        } else {
        this.servicio.buscarinformeVarios(valoresInformes,nombreInforme,val)
        }
      } else{
        this.mensajeria.mensajeMuestro('Debe seleccionar las fechas. Por favor verifique.','Advertencia!','Advertencia')
      }
    })
  }
  descargarArchivo(){
    if(NUBE_AWS) {
      this.storages.get(this.imprimirNombreInforme).then((val) => {
        if(val){
          let data = JSON.parse(val)
          this.servicio.exportToExcel(data, 'informe-cuentas-por-cobrar')
          .then((result: any) => {
              console.log('result', result)
            }).catch((error)=> {
              console.log('error', error)
            })
        }else{
          this.mensajeria.mensajeMuestro('Debe buscar Información antes de poder descargarla. Por favor verifique','Advertencia!','Advertencia')
          return false
        }
      })
    } else {
      if(this.imprimirNombreInforme!=''){
        this.iab.create(`${URL_SERVICIOS_LOCALESFRONT}/assets/${this.imprimirNombreInforme}.xlsx`,'_system')
      }else{
        this.mensajeria.mensajeMuestro('No hay información para mostrar','Debe buscar Información antes de poder descargarla. Por favor verifique','error')
      }
    }
  }

  imprimirRecibo(){
    this.storages.get(this.imprimirNombreInforme).then((val) => {
      if(val){
        let data = JSON.parse(val)
        let Obj = this.armarImpresion(data)
        this.reemprimirRecibo(Obj)
      }else{
        this.mensajeria.mensajeMuestro('Debe buscar Información antes de poder imprimirla','Advertencia!','Advertencia')
      }
    })

  }

  visualizarInformacion(){

    this.storages.get(this.imprimirNombreInforme).then((val) => {
      if(val){
        let data = JSON.parse(val)
        this.generarGrid(data)
      }else{
        this.mostrarMensajes('Debe buscar Información antes de poder visualizarla','Verifique')
      }
    })
  }

  armarImpresion(data:any){
    let Obj = []
    for (let item of data) {
      let cadena = ''

      for (const key of Object.keys(item)) {

        cadena =`${item[key]}`
        let valores = `${key} :  ${cadena}`
        Obj.push({'reciboCaja':valores})
        cadena=''
        }
    }
    return Obj
  }
  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }

  reemprimirRecibo(mensaje) {
    let recibo = ''

  for (let index:any = 0; index < mensaje.length; index++) {
    recibo += mensaje[index]['reciboCaja'] + '\n'
  }

    this.servicio.imprimirRecibo(recibo).subscribe(
        res => {

        },
        err => {

                let alert = this.alertControllers.create({
                    title: '',
                    subTitle: recibo,
                    buttons: ['Cerrar']
                });
                alert.present();
            })
  }

  generarGrid(data:any){

    let cadena = ''
    let cabeza = ''
    let eliminarCampo = false

    let dataNueva = []
    let dataNuevaTemp = []
    if(data.length>1){
      eliminarCampo = true
    }

    for(var i = 0; i< data.length;i++){
      if(i==0){
        cadena+= `${ Object.keys(data[i])},`
        i = data.length + 1
      }
    }
    cadena = cadena.substr(cadena.length - 1, 1) == ',' ? cadena.substring(0, cadena.length - 1) : cadena;
    cadena  = cadena + '\n'

    for (let item of data) {
      for (const key of Object.keys(item)) {
        cadena+=`${item[key]},`
        }
        cadena=`${cadena}\n`
    }


    cadena = cadena.substr(cadena.length - 1, 1) == ',' ? cadena.substring(0, cadena.length - 1) : cadena;


    let realvalorgrid = ''

    realvalorgrid = `${cadena}`

    this.parsedData = papa.parse(realvalorgrid).data


      this.parseDataHeader =  this.parsedData[0]


    if(eliminarCampo){
      this.parsedData.splice(0,1)
    }

    this.parsedDataReal = this.parsedData

  }

  trackByFn(index:any,item:any){
    return index;
  }

  public requestAutocompleteItems = (text: string): Observable<Response> => {
    return this.servicioClientes.buscarClientesPorCompania(text, this.companiasId)
  };

  async generarPDFPlanDePago() {
    this.isLoading = true;
    let responseCompania = await this.dian.devolverCompania()
    this.companiasId = this.companiasId == undefined ? responseCompania : this.companiasId

    if(this.companiasId == undefined) {
      this.companiasId = 2
    }
      if(this.resumenCuentasPorCobrarPlanDePago.length > 0){
        let datanew = this.resumenCuentasPorCobrarPlanDePago
        let recibo = ''
        let data = []

        let nombreCompleto = this.resumenCuentasPorCobrarPlanDePago[0].nombreCompleto
        let nombreEntidad = this.resumenCuentasPorCobrarPlanDePago[0].nombreEntidad
        for (let index:any = 0; index < datanew.length; index++) {
          let numerovalorPagado = datanew[index].valorPagado.toLocaleString('en');
          let numerovalorCuota = datanew[index].valorCuota.toLocaleString('en');
          if(index === 0) {
            recibo +=  '   # cuota ' + 'Fecha vencimiento '  + 'Valor cuota ' + 'Valor pagado '  + 'Fecha pago ' + '\n'
          }
          let fechaV = datanew[index].fechaVencimiento ? datanew[index].fechaVencimiento.substring(0,10) : ' - '
          let fechaP = datanew[index].fechaPagado ? datanew[index].fechaPagado.substring(0,10) : ' - '


          recibo +=  datanew[index].nroCuota + '             ' + fechaV + '             ' + numerovalorCuota + '           ' + numerovalorPagado + '              ' + fechaP + '\n'
        }
        data.push(recibo)

        const estilo = {
          encabezado: {
            fontSize: 13,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 10], // Margen inferior de 10 unidades
          },
          parrafo: {
            fontSize: 11,
            alignment: 'center',
            margin: [0, 0, 0, 5], // Margen inferior de 5 unidades
          },
          cita: {
            italics: true,
            alignment: 'center',
            margin: [0, 0, 0, 10], // Margen inferior de 10 unidades
          },
          lista: {
            fontSize: 11,
            bold: true,
            margin: [0, 0, 0, 5], // Margen inferior de 5 unidades
          },
        };

    const docDefinition = {
      content: [
        {
          image: await this.getBase64ImageFromURL(`assets/imgs/${this.companiasId}.jpeg`),
          width: 200, // Ancho de la imagen en unidades
          alignment: 'center',
        },
    { text: 'Plan de pago ' , style: 'encabezado' },
    { text: nombreCompleto, style: 'encabezado' },
    { text: nombreEntidad, style: 'encabezado' },
     { text: '\n' },
        {
          ul: data.map((dato) => {
            return dato.toString();
          }),
          style: 'lista',
        },
      ],
      styles: estilo
    };



    pdfMake.createPdf(docDefinition).download(`plan-de-pago-${nombreEntidad}-${nombreCompleto}.pdf`);
    this.isLoading = false;
    }
      else{
        this.mensajeria.mensajeMuestro('Debe buscar Información antes de poder generar el pdf','Advertencia!','Advertencia')
      }
      this.isLoading = false;
  }
  buscarClienteSelect() {
   this.buscarClientes()
  }
 async buscarClientes() {
    let responseCompania = await this.dian.devolverCompania()
      let companiaId = this.companiasId == undefined ? responseCompania : this.companiasId

      if(companiaId == undefined) {
        this.mensajeria.mensajeMuestro('Debe salir y volver a entrar a la aplicación para generar la nota crédito..','Advertencia!','advertencia')
        return
      }
    this.servicioClientes.buscarClientesPorCompaniaAll(companiaId)
    .subscribe(async (data: any)=>{
      let clientes: any = data;
      this.listaClientes = clientes;

      let modal = this.modalControllers.create(ClienteSelectPage, { data: this.listaClientes }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
          this.clienteId.push({value:data.value, display:data.display})
          let cliente: valueDisplay[] = [{
            value:data.value,
            display:data.display
          }]
          this.clienteId = cliente
          // const actionClienteCaja = new fromData.CargarValueDisplaySuccessActions(cliente);
          const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
          this.store.dispatch(actionClienteCaja);
          this.valoresCliente = 'Buscar Cliente : ' + data.display;
        }
      })
    })
  }

  descargarArchivoExcel(){


    if(this.resumenSeguimientosCuentasPorCobrar.length > 0){
          let data = this.resumenSeguimientosCuentasPorCobrar
          this.servicio.exportToExcel(data, 'seguimientos-cuentas-por-cobrar')
          .then((result: any) => {
              console.log('result', result)
            }).catch((error)=> {
              console.log('error', error)
            })
        }else{
          this.mensajeria.mensajeMuestro('No se logro la información','Advertencia!','Advertencia')
          return false
        }

  }

  public requestAutocompleteItemsEntidad = (text: string): Observable<Response> => {
    return this.servicioEntidades.buscarEntidadPorCompania(text, this.companiasId)
  };

}

class TodasConSaldo {
  public nombre:string;
  public valor:string
}



// WEBPACK FOOTER //
// ./src/pages/informe-cuentas-por-cobrar/informe-cuentas-por-cobrar.ts